import React from "react";
import { Screen, ScreenHeader, ScreenBody, screenConnect } from "@screen";
import { ModalButton } from "@modal";
import { ceScreenViewTextVersionCancel } from "@js/actions/studio/campaign_content_section/screen_view_text_version.js";

const ScreenViewTextVersion = (props) => {
  return (
    <Screen>
      <ScreenHeader>
        <div
          style={{
            paddingLeft: "19px",
            paddingTop: "12px",
            display: "inline-block",
            float: "left",
          }}
        />
        <div
          style={{
            paddingRight: "19px",
            paddingTop: "12px",
            display: "inline-block",
            float: "right",
          }}
        >
          <ModalButton
            onClick={() => props.dispatch(ceScreenViewTextVersionCancel())}
            text={t("buttons.cancel")}
            diminished
          />
        </div>
      </ScreenHeader>
      <ScreenBody style={{ backgroundColor: "#EEE", overflowY: "hidden" }}>
        <div
          id="screenViewTextVersion"
          style={{
            width: "100%",
            maxWidth: "900px",
            minHeight: "500px",
            height: "100%",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            backgroundColor: "#FFF",
            overflowY: "scroll",
          }}
        >
          <pre>{props.text}</pre>
        </div>
      </ScreenBody>
    </Screen>
  );
};

export default screenConnect(ScreenViewTextVersion);
